import Image from 'next/image';

import { Box, Button, Modal, Text, TextButton } from '@zillow/constellation-10';

import { getActiveProductTypePremiumFeatures } from '../../../../Freemium/components/FeaturesOfPremium/constants';

import PremiumBadge from '../../../../../assets/premium-badge.png';

const getButtonComponent = (as: string) => {
  if (as === 'Button') {
    return Button;
  }

  if (as === 'TextButton') {
    return TextButton;
  }

  return Button; // default fallback
};

type LearnAboutPremiumButtonProps = {
  as: 'Button' | 'TextButton';
  children: React.ReactNode;
};

const LearnAboutPremiumButton = ({ as = 'Button', children }: LearnAboutPremiumButtonProps) => {
  const ComponentButton = getButtonComponent(as);

  return (
    <Modal
      data-testid="PremiumOverviewModal"
      dividers={false}
      size={{
        base: 'fullScreen',
        lg: 'md',
      }}
      trigger={<ComponentButton data-test="LearnAboutPremiumButton">{children}</ComponentButton>}
      body={
        <>
          <Box css={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Image src={PremiumBadge} alt="premium badge" width={130} height={130} />

            <Box css={{ marginBottom: '400' }} />

            <Text textStyle="heading-sm" asChild>
              <p>Premium gives you more of what you need to successfully manage your business</p>
            </Text>
          </Box>
          <Box css={{ marginBottom: '600' }} />
          <div data-testid="PremiumFeatureList">
            {getActiveProductTypePremiumFeatures().map((item) => {
              const { heading, modalContent } = item;

              return (
                <Box key={heading} data-testid="PremiumFeatureItem" css={{ marginBottom: '600' }}>
                  <Text textStyle="body-bold" asChild>
                    <p>{heading}</p>
                  </Text>
                  <Text asChild>
                    <p>{modalContent}</p>
                  </Text>
                </Box>
              );
            })}
          </div>
        </>
      }
    />
  );
};

export default LearnAboutPremiumButton;
